import { useEffect, useRef } from 'react'
import { required } from 'react-admin'
import { useFormContext, useWatch } from 'react-hook-form'

import config from './config'
import AdvancedReferenceInput from '../../components/AdvancedReferenceInput'
import organisationsConfig from '../organisations/config'

const HubReferenceInput = ({ readOnly = false, ...props }) => {
  const organisationId = useWatch({ name: organisationsConfig.options.referenceKey })
  const { getValues, setValue } = useFormContext()
  const previousOrganisationId = useRef(organisationId)

  useEffect(() => {
    const organisationChanged = previousOrganisationId.current && previousOrganisationId.current !== organisationId
    previousOrganisationId.current = organisationId

    if (organisationChanged && getValues(config.options.referenceKey)) {
      setValue(config.options.referenceKey, null, { shouldDirty: true })
    }
  }, [getValues, organisationId, setValue])

  return (
    <AdvancedReferenceInput
      disableAutoSelect={!organisationId}
      filter={{ organisation_id: organisationId }}
      readOnly={readOnly || !organisationId}
      reference={config.name}
      sort={config.options.defaultSort}
      source={config.options.referenceKey}
      validate={required()}
      {...props}
    />
  )
}

export default HubReferenceInput
